import React from 'react'
import { BackTop, Layout } from 'antd'
import { useSelector } from 'react-redux'
import classNames from 'classnames'
import TopBar from 'components/LayoutComponents/TopBar'
import Footer from 'components/LayoutComponents/Footer'
import Settings from 'components/LayoutComponents/Settings'

import './style.scss'

const ModellingLayout = (props) => {
  const { children } = props

  const { isBorderless, isSquaredBorders, isFixedWidth, isMenuShadow, isMenuTop } = useSelector(
    (state) => state.settings,
  )
  return (
    <Layout
      className={classNames({
        settings__borderLess: isBorderless,
        settings__squaredBorders: isSquaredBorders,
        settings__fixedWidth: isFixedWidth,
        settings__menuShadow: isMenuShadow,
        settings__menuTop: isMenuTop,
      })}
    >
      <BackTop />
      <Settings />
      <Layout>
        <Layout.Header>
          <TopBar isModellingPage />
        </Layout.Header>
        <Layout.Content className="layout-content">{children}</Layout.Content>
        <Layout.Footer>
          <Footer />
        </Layout.Footer>
      </Layout>
    </Layout>
  )
}

export default ModellingLayout
